import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApplicationType, ENV, LoggerService } from "@bequeathed/ngx-app-core";
import { InterviewService } from "@bequeathed/ngx-services";
import { PageUtil } from "@bequeathed/ngx-utils";
import { BaseForm } from '../../../core/ui/base-form/base-form.component';
import { AnalyticsUtils } from "../../../core/utils/analytics.utils";

const LOG: LoggerService = new LoggerService('InterviewCompleteComponent');

/**
 * Displayed when the user is unable to continue with the Will creation process. This page is usually shown if they
 * have confirmed rejection of required advice given.
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    selector: 'app-interview-cannot-complete',
    templateUrl: './cannot-complete.component.html',
    styleUrls: ['./cannot-complete.component.sass'],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
export class CannotCompleteComponent extends BaseForm implements OnInit {

    myWishesUrl: string | undefined;

    private title = inject(Title);
    protected interviewService = inject(InterviewService);
    private route = inject(ActivatedRoute);

    constructor() {
        super();

        this.title.setTitle('Will Interview : Complete');

        PageUtil.setFocus('interviewCompleteHeader');
    }

    override ngOnInit(): void {
        super.ngOnInit();

        const homeApp = ENV.applications.get(ApplicationType.HOME)!
        this.myWishesUrl = `${homeApp.baseUrl}${homeApp.api.get('dashboard')}`;

        this.route.params.subscribe((params: any) => {
            const interviewId = params['id'];
            this.analytics.trackInterviewPage(
                `/interview/WILL/${this.interviewState()?.interviewId ?? 'unknown'}/cannot-complete`,
                {
                    customer_type: AnalyticsUtils.resolveCustomerType(this.interviewService),
                    page: `/interview/WILL/${this.interviewState()?.interviewId ?? 'unknown'}/cannot-complete`,
                    interview_id: this.interviewState()?.interviewId ?? ''
                }
            )
            this.interviewService.completeProcess('WILL', interviewId).then(() => LOG.info('init', 'Process completed!'));
        });
    }
}
